"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");

var _urls = require("../../../utils/urls");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- CONTROL : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'CardControl',
  props: {
    title: {
      type: 'string',
      default: 'Basic'
    },
    recommended: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    content: {
      type: 'object',
      default: _react.default.createElement("h3", null, "This is a content.")
    },
    description: {
      type: 'string',
      default: 'Perfect for any type of community. Create a balance between showing the most recent comments, and inviting to join a conversation.'
    },
    tips: {
      type: 'string',
      default: '(entertainment sites, e-commerce sites, etc.)'
    },
    image: {
      type: 'string',
      default: "".concat(_urls.url.static.files.images, "/iui/logo-insticator-icon.svg")
    },
    value: {
      type: 'string',
      default: 'test'
    },
    selected: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    handleSelect: {
      type: 'function',
      default: function _default(value) {
        return console.log('control selected', value);
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;